module.exports = __webpack_public_path__ + "img/estebanbustos.d5e8c16d.jpg";